import EntityOverviewCard from "../UI/EntityOverviewCard";

const PlayerOverview = ({ player }) => (
  <EntityOverviewCard
    fields={[
      { label: "Name", value: player.name },
      { label: "Team", value: player.team?.name ?? "No team" },
    ]}
  />
);

export default PlayerOverview;
